import TopupDeposit from "./views/TopupDeposit";
import PaketDepositDetailTopup from "./../../customer/paket-deposit/views/PaketDepositDetailTopup";

const requireAuth = {requireAuth: true}
const route = {
	path: '/transaksi/deposit/topup', component: {
		render(c) {
			return c('router-view')
		}
	},
	children: [
		{
			path: '',
			name: "TopupDeposit",
			component: TopupDeposit,
			meta: {
				...requireAuth,
				accessKey: 'transaction.topupDeposit',
			},
		},
		{
			path: ':idtransaksi',
			name: "PaketDepositDetailTopup",
			component: PaketDepositDetailTopup,
			meta: {
				...requireAuth,
				accessKey: 'topupDeposit.read',
			},
		},
	]
}

export default router => {
	router.addRoutes([route])
}
